<template>
  <div class="column content-box">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="add-circle"
      @click="openAddPopup"
    >
      {{ $t('LABEL_MGMT.HEADER_BTN_TXT') }}
    </woot-button>
    <woot-tabs
      v-if="availableTypes.length > 1"
      :index="selectedTabIndex"
      @change="onClickTabChange"
    >
      <woot-tabs-item
        v-for="type in availableTypes"
        :key="type.key"
        :name="$t(`${type.i18nPrefix}.HEADER`)"
        :show-badge="false"
      />
    </woot-tabs>
    <label-list :key="selectedType.key" :type="selectedType.key" />
    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <add-label :initial-type="selectedType.key" @close="hideAddPopup" />
    </woot-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import AddLabel from './AddLabel';
import LabelList from './LabelList';
import { getAvailableLabelTypes } from './labelTypes';

export default {
  components: {
    AddLabel,
    LabelList,
  },
  data() {
    return {
      showAddPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    availableTypes() {
      return getAvailableLabelTypes(flag =>
        this.isFeatureEnabledonAccount(this.accountId, flag)
      );
    },
    selectedTabIndex() {
      const index = this.availableTypes.findIndex(
        type => type.key === this.$route.query.tab
      );
      return index === -1 ? 0 : index;
    },
    selectedType() {
      return this.availableTypes[this.selectedTabIndex];
    },
  },
  methods: {
    onClickTabChange(index) {
      const { key } = this.availableTypes[index];
      if (key === this.$route.query.tab) return;
      this.$router.replace({ query: { ...this.$route.query, tab: key } });
    },
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
  },
};
</script>

<style scoped lang="scss">
.tabs {
  padding-left: 0;
  margin-bottom: var(--space-normal);
  user-select: none;
}

::v-deep {
  .tabs-title a {
    font-weight: var(--font-weight-medium);
    padding-top: 0;
  }
}
</style>
